<template>
  <div class="register">
    <div style="height: 50px"></div>
    <div class="step flex">
      <div v-for="(v, i) in step" :key="i"  :class="`item flex ${ index >= i ? 'on' : ''}`">
        <span class="tag">{{i + 1}}</span>
        <span class="txt">{{v}}</span>
      </div>
      
    </div>
    <div class="main container">
      <div class="box-1" v-show="index === 0">
        <div class="item flex">
          <div class="name">手机号</div>
          <el-input v-model.number="tel" placeholder="点击输入手机号" :disabled="codeDisabled" style="width: 300px" />
        </div>
        <div style="height: 40px"></div>
        <div class="item flex">
          <div class="name">验证码</div>
          <el-input v-model.number="code" style="width: 120px" />
          <div style="width: 40px"></div>
          <el-button type="info" :disabled="codeDisabled"  @click="getCode" :loading="codeLoading">{{codeBtnTxt}}</el-button>
        </div>
        <div style="height: 40px"></div>
        <el-button type="primary" size="large" :loading="regloading" class="regTel" @click="regTel">下一步</el-button>
      </div>
      <div class="box-2" v-show="index === 1">
        <div class="item flex">
          <div class="name">密码</div>
          <el-input v-model="pass1" type="password" placeholder="点击输入密码" style="width: 300px" />
        </div>
        <div style="height: 40px"></div>
        <div class="item flex">
          <div class="name">确认密码</div>
          <el-input v-model="pass2" type="password" placeholder="点击输入密码" style="width: 300px" />
        </div>
        <div style="height: 40px"></div>
        <el-button type="primary" size="large" :loading="postLoading" class="regTel" @click="handlebtn">注册</el-button>
      </div>
      <div class="box-3" v-show="index === 2">
        <svg t="1653557603840" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2898" width="200" height="200"><path d="M512 85.333333c235.648 0 426.666667 191.018667 426.666667 426.666667s-191.018667 426.666667-426.666667 426.666667S85.333333 747.648 85.333333 512 276.352 85.333333 512 85.333333z m-74.965333 550.4L346.453333 545.152a42.666667 42.666667 0 1 0-60.330666 60.330667l120.704 120.704a42.666667 42.666667 0 0 0 60.330666 0l301.653334-301.696a42.666667 42.666667 0 1 0-60.288-60.330667l-271.530667 271.488z" fill="#52C41A" p-id="2899"></path></svg>
        <div style="height: 20px"></div>
        <h2>恭喜！注册成功</h2>
        <div style="height: 40px"></div>
        <el-button type="primary" size="large" class="goLogin" @click="handleLogin">前往登录</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import { getCurrentInstance, reactive, toRefs, onBeforeUnmount } from "vue"
import { validateTel } from "@/tools"
import { ElMessage, ElNotification  } from 'element-plus'
import { api } from '@/api'

export default {
  name: "register",
  setup() {
    const { proxy } = getCurrentInstance()
    let initData = reactive({
      index: 0,
      step: ["验证手机号码", "设置密码", "注册成功"],
      tel: "", // 手机号

      // 验证码 -- start -- 
      code: "",
      codeDisabled: false,
      codeTime: 120,
      codeLoading: false,
      codeBtnTxt: "获取验证码",
      timer: "",

      regloading: false,
      // 验证码 -- end -- 

      pass1: "",
      pass2: "",
      postLoading: false,
    })

    // 获取验证码
    function getCode() {
      if(validateTel(initData.tel)) {
        initData.codeLoading = true
        initData.codeDisabled = true
        // 获取验证码
        api("get", "smsSignCodeByPc", {phone: initData.tel, type: 0, appcode: '5101'})
          .then(res => {
            initData.codeLoading = false
            if(res.code === 1200) {
              ElNotification({
                title: '提示',
                message: '验证码已发送到手机，请注意查收.',
                type: 'success',
              })
              initData.codeTime = 120
              initData.timer = setInterval(() => {
                if(initData.codeTime === 0) {
                  initData.codeDisabled = false
                  initData.codeBtnTxt = "获取验证码"
                  clearInterval(initData.timer)
                  initData.timer = null
                } else {
                  initData.codeTime -= 1
                  initData.codeBtnTxt = `重新获取 ${initData.codeTime} S`
                }
              }, 1000)
            } else {
              ElNotification({
                title: '提示',
                message: res.msg,
                type: 'error',
              })
            }
          })
          .catch(err => {
            initData.codeLoading = false
            ElNotification({
              title: '提示',
              message: '验证码获取失败！请重新尝试.',
              type: 'error',
            })
          })
      } else {
        ElMessage.warning('请输入正确的手机号码.')
      }
    }
    // 验证手机号是否可用
    function regTel() {
      if(initData.code) {
        initData.regloading = true
        api("get", "checkSmsCode", {phone: initData.tel, smsCode: initData.code})
          .then(res => {
            initData.regloading = false
            if(res.code === 1200) {
              initData.index += 1
            } else {
              ElNotification({
                title: '提示',
                message: res.msg,
                type: 'error',
              })
            }
          })
          .catch(err => {
            initData.regloading = false
            ElNotification({
              title: '提示',
              message: '验证码校验失败！请重新尝试.',
              type: 'error',
            })
          })
      } else {
        ElMessage.warning('请输入短信验证码.')
      }
    }
    // 注册
    function handlebtn() {
      if(initData.pass1.length < 4 || initData.pass1.length > 16) {
        ElMessage.warning('请输入4至16位长度的密码.')
      } else if(initData.pass1 !== initData.pass2) {
        ElMessage.warning('两次密码不一致.')
      } else {
        let data = {
          appcode: "5101",
          password: initData.pass1,
          type: 5,
          username: initData.tel
        }
        initData.postLoading = true
        api("post", "register", data)
          .then(res => {
            initData.postLoading = false
            if(res.code === 1200) {
              initData.index += 1
            } else {
              ElNotification({
                title: '提示',
                message: res.msg,
                type: 'error',
              })
            }
          })
          .catch(err => {
            initData.postLoading = false
            ElNotification({
              title: '提示',
              message: '注册失败！请重新尝试.',
              type: 'error',
            })
          })
      }
    }
    function handleLogin() {
      proxy.$mitt.emit("showLogin", "");

    }
    onBeforeUnmount(() => {
      if(initData.timer) clearInterval(initData.timer)
    })
    return {
      ...toRefs(initData),
      getCode,
      regTel,
      handlebtn,
      handleLogin
    }
  }
}
</script>

<style lang="less" scoped>
.register {
  min-height: calc(100vh - 80px);
  background-color: #f7f8fa;
  .step {
    width: 1200px;
    justify-content: center;
    margin: 0 auto;
    border-bottom: 2px solid #e6e6e6;
    box-sizing: border-box;
    background-color: #fff;
    .item.on {
      &::after {
        content: "";
        height: 2px;
        position: absolute;
         background-color: #10bb58;
        left: 0;
        right: 0;
        bottom: -2px;
      }
      .tag {
        background-color: #10bb58;
      }
      
    }
    .item {
      width: 250px;
      height: 45px;
      align-items: center;
      justify-content: center;
      position: relative;
      .tag {
        width: 24px;
        height: 24px;
        line-height: 1;
        background-color: #ccc;
        display: flex;
        align-items: center;
        justify-content: center;
        color: #fff;
        border-radius: 50%;
      }
      
      .txt {
        margin-left: 10px;
      }
    }
  }
  .main {
    height: 500px;
    background-color: #fff;
    padding-top: 50px;
    box-sizing: border-box;
    .box-1 {
      .item {
        width: 500px;
        margin: 0 auto;
        align-items: center;
        .name {
          width: 80px;
          color: #585858;
        }
      }
      .regTel {
        width: 200px;
        margin-left: 430px;
      }
    }
    .box-2 {
      .item {
        width: 500px;
        margin: 0 auto;
        align-items: center;
        .name {
          width: 80px;
          color: #585858;
        }
      }
      .regTel {
        width: 200px;
        margin-left: 430px;
      }
      
    }
    .box-3 {
      text-align: center;
      .goLogin {
        width: 200px;
      }
    }
  }
}

</style>